export default "__VITE_ASSET__DBNZY_zD__"